var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dapp-module"},[_c('div',{staticClass:"dapp-pic"},[_vm._t("dapp-pic")],2),_vm._v(" "),_c('div',{staticClass:"dapp-title"},[_vm._t("dapp-title")],2),_vm._v(" "),_c('div',{staticClass:"dapp-content"},[_vm._t("dapp-content")],2),_vm._v(" "),_c('div',{staticClass:"dapp-link"},[_vm._t("dapp-link")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea5b3884","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/developer/plugins/dAppModule.vue
// module id = null
// module chunks = 